import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import CardNews from '../../shared/components/CardNews/CardNews'
import Button from '../../shared/components/Button/Button'
import { motion, AnimatePresence } from 'framer-motion'
import './styles.scss'

const NewsMobile = ({ posts, kind_of_news }) => {
  const [visiblePosts, setVisiblePosts] = useState([])

  useEffect(() => {
    setVisiblePosts(posts.slice(0, 2))
  }, [posts])

  const loadMorePosts = () => {
    const nextPage = visiblePosts.length / 2 + 1
    const newPosts = posts.slice(0, nextPage * 2)
    setVisiblePosts(newPosts)
  }
  return (
    <div className="mobile-wrapper">
      <AnimatePresence>
        {visiblePosts.map((post, index) => (
          <motion.div
            key={index}
            transition={{
              duration: 0.7,
              delay: 0.7,
            }}
            viewport={{
              once: true,
            }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            exit={{ opacity: 1 }}
            className="embla__mobile"
          >
            <CardNews
              key={index}
              imageSrc={post.featuredImage}
              title={post.title}
              description={post.excerpt}
              link={post.url}
              kind_of_news={kind_of_news}
              target={kind_of_news === 'Blog' ? '_parent' : '_blank'}
            />
          </motion.div>
        ))}
      </AnimatePresence>
      {visiblePosts.length < posts.length && (
        <Button
          className="readmore__post"
          action={loadMorePosts}
          name="READ MORE"
          link=""
          type="button"
          showLabel={true}
          icon="ArrowRight"
        />
      )}
    </div>
  )
}

export default NewsMobile

NewsMobile.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      excerpt: PropTypes.string,
      url: PropTypes.string,
      featuredImage: PropTypes.string,
    }),
  ).isRequired,
}
